import { useEffect, useState } from 'react';
import { CustomTable, RowSale } from '..';
import { format, parseISO } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { es } from 'date-fns/locale';
import { TableCell, TableContainer, Table, TableHead, TableRow, Paper, TableBody } from '@mui/material';
import { ccyFormat } from '../../helpers/helper';

const TableSale = ({ sales }) => {
  const Headers = () => (
    <TableHead>
      {/* <TableCell />
      <TableCell>Articulo</TableCell>
      <TableCell align="right">SKU</TableCell>
      <TableCell align="right">Cantidad</TableCell>
      <TableCell align="right">Precio ($)</TableCell> */}
      <TableRow>
        <TableCell align="center" colSpan={5}>
          Details
        </TableCell>
        <TableCell align="right">Price</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Descripcion</TableCell>
        <TableCell align="right">Fecha</TableCell>
        <TableCell align="right">P. Unit. Compra</TableCell>
        <TableCell align="right">P. Unit. Venta</TableCell>
        <TableCell align="right">Cantidad</TableCell>
        <TableCell align="right">Sum</TableCell>
      </TableRow>
    </TableHead>
  )


  const Rows = () => (
    //sales?.map(sale => <RowSale key={sale._id} row={sale} />)
    rows?.map(row => 
    <TableRow key={row.key}>
      <TableCell>{row.desc}</TableCell>
      <TableCell align="right">{row.date}</TableCell>
      <TableCell align="right">{row.compra}</TableCell>
      <TableCell align="right">{row.unit}</TableCell>
      <TableCell align="right">{row.qty}</TableCell>
      <TableCell align="right">{ccyFormat(row.price)}</TableCell>
    </TableRow>)
  )
  // return (
  //   <CustomTable
  //     Headers={() => Headers()}
  //     Rows={() => Rows()}
  //   />
  // )

  // // const rows = [
    // //   createRow('Paperclips (Box)', 100, 1.15),
    // //   createRow('Paper (Case)', 10, 45.99),
    // //   createRow('Waste Basket', 2, 17.99),
    // // ];
  
  const [rows, setRows] = useState([])

  const zonaHoraria = 'America/Buenos_Aires';
  const fechaEnZonaHoraria = (date) => utcToZonedTime(parseISO(date), zonaHoraria);
  const fechaFormateada = (date) => format(fechaEnZonaHoraria(date), "PPPP", { timeZone: zonaHoraria, locale: es });
  
  const CreateRows = () => {
    if(sales) {
      setRows(sales.map(sale => createRow(sale)))
    }
  }

  useEffect(() => {
    if(sales?.length > 0)
      CreateRows()
  }, [])

  const totals = calculateTotals(rows);
  const ganancias = totals.priceSum - totals.priceBuy;

  function priceRow(qty, unit) {
    return qty * unit;
  }
  
  const createRow = (sale) => {
    const key = sale._id
    const desc = sale.article?.name
    const compra = sale.prices_sold.list_price
    const unit = sale.prices_sold.sale_price
    const qty = sale.quantity_sold
    const price = priceRow(qty, unit);
    const date = fechaFormateada(sale.created_at)
    return { key, desc, date, compra, unit, qty, price };
  }

  // function createRow(key, desc, fecha, compra, unit, qty) {
  //   const price = priceRow(qty, unit);
  //   const date = fechaFormateada(fecha)
  //   return { key, desc, date, compra, unit, qty, price };
  // }

  function calculateTotals(items) {
    return items?.reduce((totals, item) => {
      totals.priceSum += item.price;
      totals.priceBuy += item.compra * item.qty; // Cambia 'otherColumn' al nombre de la otra columna que quieras sumar
      return totals;
    }, { priceSum: 0, priceBuy: 0 });
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="spanning table">
        <Headers />
        <TableBody>
          {rows && <Rows />}
          <TableRow>
            <TableCell rowSpan={3} />
            <TableCell colSpan={4}>Total Ventas</TableCell>
            <TableCell align="right">{ccyFormat(totals.priceSum)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={4}>Total Compras</TableCell>
            {/* <TableCell align="right">{`${(TAX_RATE * 100).toFixed(0)} %`}</TableCell> */}
            <TableCell align="right">{ccyFormat(totals.priceBuy)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={4}>Total Ganancias</TableCell>
            <TableCell align="right">{ccyFormat(ganancias)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default TableSale;